"use client";

import { useAuth, useUser } from "@clerk/nextjs";
import { Typography } from "@cappelendamm/design-system/react";
import { PiBuildingOfficeLight, PiUserLight } from "react-icons/pi";
import { isFeideUser } from "@/auth/utils";

export const OrganizationBanner = () => {
  const { orgId } = useAuth();
  const { user, isLoaded } = useUser();

  if (!isLoaded || !user) return null;

  let displayName: string | null = null;

  if (isFeideUser(user)) {
    displayName =
      (user.publicMetadata?.activeSchoolName as string | null) ?? null;
  } else if (orgId) {
    // Non-Feide organization users may not always have organization context
    // immediately available during auth transitions.
    displayName = "Organisasjon";
  }

  if (!displayName) return null;

  return (
    <div className="grid w-full items-center bg-[#49678F] bg-size-[15px_15px] bg-fixed p-2 text-white sm:flex sm:justify-between">
      <div className="flex min-w-0 items-center gap-2">
        <PiBuildingOfficeLight className="inline shrink-0" size={22} />
        <Typography variant="body-base" className="truncate whitespace-nowrap">
          {displayName}
        </Typography>
      </div>
      <div className="hidden items-center gap-1 sm:flex">
        <PiUserLight className="inline shrink-0" size={22} />
        <Typography
          variant="body-base"
          className="truncate text-right whitespace-nowrap"
        >
          {user.firstName?.replace(/^\S/, (c) => c.toUpperCase())}
        </Typography>
      </div>
    </div>
  );
};
